module.exports = __webpack_public_path__ + "static/img/twipro1.d73ab40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/twipro1.jpg
// module id = 2QUO
// module chunks = 0